"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  setAllLoading: function setAllLoading() {
    return {
      type: 'VACANCIES_ALL_LOADING'
    };
  },
  getList: function getList(data) {
    return request.post('vacancies', data, function (res, dispatch) {
      var data = res.data,
        items = data.items;
      if (!items) items = [];
      dispatch({
        type: 'VACANCIES_ALL',
        items: items
      });
      return res;
    });
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzZXRBbGxMb2FkaW5nIiwidHlwZSIsImdldExpc3QiLCJkYXRhIiwicmVxdWVzdCIsInBvc3QiLCJyZXMiLCJkaXNwYXRjaCIsIml0ZW1zIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vbGlicmFyeS9zcmMtY2xpZW50L21vZHVsZXMvVmFjYW5jeS9WYWNhbmN5QWN0aW9ucy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCB7XG4gICAgc2V0QWxsTG9hZGluZzogKCkgPT4ge1xuICAgICAgICByZXR1cm4ge3R5cGU6ICdWQUNBTkNJRVNfQUxMX0xPQURJTkcnfTtcbiAgICB9LFxuICAgIGdldExpc3Q6IChkYXRhKSA9PiByZXF1ZXN0LnBvc3QoJ3ZhY2FuY2llcycsIGRhdGEsIChyZXMsIGRpc3BhdGNoKSA9PiB7XG4gICAgICAgIGxldCBkYXRhID0gcmVzLmRhdGEsXG4gICAgICAgICAgICBpdGVtcyA9IGRhdGEuaXRlbXM7XG4gICAgICAgIGlmICghaXRlbXMpIGl0ZW1zID0gW107XG4gICAgICAgIGRpc3BhdGNoKHt0eXBlOiAnVkFDQU5DSUVTX0FMTCcsIGl0ZW1zfSk7XG4gICAgICAgIHJldHVybiByZXM7XG4gICAgfSlcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O29DQUFlO0VBQ1hBLGFBQWEsRUFBRSxTQUFmQSxhQUFhQSxDQUFBLEVBQVE7SUFDakIsT0FBTztNQUFDQyxJQUFJLEVBQUU7SUFBdUIsQ0FBQztFQUMxQyxDQUFDO0VBQ0RDLE9BQU8sRUFBRSxTQUFUQSxPQUFPQSxDQUFHQyxJQUFJO0lBQUEsT0FBS0MsT0FBTyxDQUFDQyxJQUFJLENBQUMsV0FBVyxFQUFFRixJQUFJLEVBQUUsVUFBQ0csR0FBRyxFQUFFQyxRQUFRLEVBQUs7TUFDbEUsSUFBSUosSUFBSSxHQUFHRyxHQUFHLENBQUNILElBQUk7UUFDZkssS0FBSyxHQUFHTCxJQUFJLENBQUNLLEtBQUs7TUFDdEIsSUFBSSxDQUFDQSxLQUFLLEVBQUVBLEtBQUssR0FBRyxFQUFFO01BQ3RCRCxRQUFRLENBQUM7UUFBQ04sSUFBSSxFQUFFLGVBQWU7UUFBRU8sS0FBSyxFQUFMQTtNQUFLLENBQUMsQ0FBQztNQUN4QyxPQUFPRixHQUFHO0lBQ2QsQ0FBQyxDQUFDO0VBQUE7QUFDTixDQUFDIiwiaWdub3JlTGlzdCI6W119